export default __webpack_public_path__ + "static/media/Snd_U_Starts.9ce65a90.mp3";